<template>
  <modal
    :modal-id="modalId"
    :title="modalTitle"
    :preloader="preloader"
    @submit="submit"
    @close-modal="closeModal"
  >
    <template slot="body">
      <app-overlay-loader v-if="preloader" />
      <form
        class="mb-0"
        :class="{ 'loading-opacity': preloader }"
        ref="form"
        :data-url="selectedUrl ? `${addurl}/${inputs.id}` : addurl"
      >
        <div class="row">
          <div class="col-md-12 form-group align-items-center">
            <label for="inputs_title">
              {{ $t("title") }}
            </label>
            <app-input
              id="inputs_title"
              type="text"
              v-model="inputs.title"
              placeholder="Enter Title"
              :required="true"
            />
          </div>
        </div>
        <div class="row" v-if="showDescriptionEditor">
          <div class="col-md-12 form-group align-items-center">
            <label for="inputs_description">
              {{ $t("description") }}
            </label>
            <app-input
              id="inputs_description"
              type="text-editor"
              placeholder="Enter Description"
              v-model="inputs.description"
              :required="true"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-md-12 form-group align-items-center">
            <label for="inputs_disclaimer">
              {{ $t("disclaimer") }}
            </label>
            <app-input
              id="inputs_disclaimer"
              type="textarea"
              placeholder="Enter Disclaimer"
              v-model="inputs.disclaimer"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-md-12 form-group align-items-center">
            <label for="inputs_type">
              {{ $t("select_type") }}
            </label>
            <app-input
              id="inputs_type"
              type="search-select"
              placeholder="Select Type"
              v-model="inputs.type"
              :list='typeList'
              :required="true"

            />
          </div>
        </div>
        <div class="row">
          <div class="col-md-12 form-group align-items-center">
            <label for="inputs_category_name" >
              {{ $t("select_category") }}
            </label>
            <app-input
              id="inputs_category_name"
              type="search-select"
              placeholder="Select Category"
              v-model="inputs.category_id"
              :list='categorylist'
            />
            <p v-if="categoryAddShow == false" class="font-italic text-muted">
              {{ $t("shortcut_category_create") }} <span><a href="#" @click.prevent="addCategory()">{{$t("add_category")}}</a></span>
            </p>
            <div v-if="categoryAddShow == true" class="mt-2">
              <div class="d-flex align-items-center">
                <app-input
                  class="mr-2 flex-grow-1"
                  type="text"
                  placeholder="Enter Category Name"
                  v-model="category_name"/>
                <button type="submit"
                  class="btn btn-sm btn-primary mr-2"
                  @click.prevent="createCategory()">
                  {{ $t('save') }}
                </button>
                <a href="#" class="text-muted" @click.prevent="closeCategory()">
                    <app-icon name="x"/>
                </a>
              </div>
              <small class="text-danger ml-2" v-html="message"></small>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12 form-group align-items-center">
            <label for="inputs_package_id">
              {{ $t("select_package") }}
            </label>
            <app-input
              id="inputs_package_id"
              type="search-select"
              placeholder="Select Package"
              v-model="inputs.package_id"
              :list='packageList'
            />
            <p class="font-italic text-primary">
              {{ $t("package_assign_certificate") }}
            </p>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12 form-group align-items-center">
            <label for="inputs_expire_day">
              {{ $t("enter_expire_day") }}
            </label>
            <app-input
              id="inputs_expire_day"
              type="number"
              placeholder="Enter Numbers of Days"
              v-model="inputs.expire_day"
              :required="true"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-md-12 form-group align-items-center">
            <label for="inputs_expire_day">
              {{ $t("signature") }}
            </label>
            <VueSignaturePad
              id="signature"
              width="100%"
              height="200px"
              ref="signaturePad"
              :options="{onBegin: () => {$refs.signaturePad.resizeCanvas()}}"
            />
            <div class="mt-2 d-flex  justify-content-end align-items-center" >
              <button @click.prevent="undo" class="btn btn-danger mr-2" >Undo</button>
              <!-- <button @click.prevent="save" class="btn btn-success mr-5" >Save</button> -->
            </div>
          </div>
        </div>
        <div class="row" v-if="showSignature">
          <div class="col-md-12 form-group align-items-center">
            <label for="inputs_signature">
              {{ $t("last_signature") }}
            </label>
            <img class="mr-4" :src="signaturePath" alt="LOGO" height="auto" width="50%" />
          </div>
        </div>
        <div class="row">
          <div class="col-md-12 form-group">
              <label>
                {{ $t("upload") }}
              </label>
              <app-input
                type="custom-file-upload"
                :label="$t('upload_your_file')"
                v-model="inputs.file"
                :required="true"
              />
              <!-- <small class="text-muted font-italic">
                {{ $t("recommended_custom_file_validation") }}
              </small> -->
          </div>
        </div>
      </form>
    </template>
  </modal>
</template>

<script>
import { FormMixin } from "../../../../../core/mixins/form/FormMixin.js";
import { ModalMixin } from "../../../../Mixins/ModalMixin";
import * as actions from "../../../../Config/ApiUrl";
// import {CERTIFICATE_CATEGORY_GET} from "../../../../../app/Config/ApiUrl";
import { axiosGet, axiosPost} from "../../../../../app/Helpers/AxiosHelper";

export default {
  name: "AddModal",
  mixins: [FormMixin, ModalMixin],
  props: {
    tableId: String,
  },
  data() {
    return {
      showSignature: false,
      showDescriptionEditor: false,
      signaturePath: '',
      cat: {},
      message: '',
      categoryAddShow: false,
      category_name: '',
      addurl:actions.CERTIFICATE_STORE,
      preloader: false,
      inputs: {},
      packageList:[],
      categorylist: [],
      modalId: "demo-add-edit-Modal",
      modalTitle: this.$t("add"),
      typeList: [
        {
          id: 'membership',
          value: 'Membership'
        },
        {
          id: 'certified_membership',
          value: 'Certified Membership'
        },
        {
          id: 'compliance',
          value: 'Compliance'
        },
      ]
    }
  },
  created() {
    if (this.selectedUrl) {
      this.modalTitle = this.$t("edit");
      // this.postUrl = actions.CERTIFICATE_UPDATE;
      // this.preloader = true;
    }
    else {
      this.showDescriptionEditor = true;
    }
  },
  methods: {
    addCategory() {
      this.categoryAddShow = true;
    },
    closeCategory() {
      this.categoryAddShow = false;
    },
    createCategory() {
      if (this.category_name == '') {
          this.message = 'Category name is required';
      }
      else {
        this.cat.category_name = this.category_name;
        axiosPost(actions.CERTIFICATE_CATEGORY_STORE, this.cat)
          .then((res) => {
            this.categoryAddShow = false;
            this.$toastr.s(res.data.message);
            this.getCategories();
            this.category_name = '';
          })
          .catch((error) => {
            
          });
      }
    },
    submit() {
      const { isEmpty, data } = this.$refs.signaturePad.saveSignature();
      if(data != null) {
        this.inputs.signature = data;
      }
      else {
        this.inputs.sugnature = this.signaturePath;
      }

      let formData = new FormData();
        Object.keys(this.inputs).forEach((key) => {
          formData.append(key, this.inputs[key]);
        });
      if (this.modalTitle == "Edit") {
        this.preloader = true;
        axiosPost(actions.CERTIFICATE_UPDATE, formData)
          .then((res) => {
            
            this.$toastr.s(res.data.message);
          })
          .catch((error) => {
            
            this.$toastr.e(error);
          })
          .finally(() => {
            this.preloader = false;
            $("#demo-add-edit-Modal").modal("hide");
            this.$hub.$emit("reload-" + this.tableId);
          });
      } else {
          this.save(formData);
      }
    },
    afterSuccess(response) {
      this.$toastr.s(response.data.message);
      this.$hub.$emit("reload-" + this.tableId);
    },

    afterSuccessFromGetEditData(response) {
      // if (response.data.phone) this.phone = response.data.phone;
      this.inputs = response.data;
      if (response.data.signature != null) {
          this.signaturePath = response.data.signature;
          this.showSignature = true;
      }
      this.inputs.file = response.data.logo;
      this.showDescriptionEditor = true;
      this.preloader = false;
    },

    getCategories() {
      axiosGet(actions.CERTIFICATE_CATEGORY_GET)
        .then((res) => {
          this.categorylist = res.data;
        })
        .catch((error) => { 
          
        });
    },
    getPackages() {
      axiosGet(actions.GET_PACKAGES)
        .then((res) => {
          this.packageList = res.data;
        })
        .catch((error) => { 
          
        });
    },
    undo() {
      this.$refs.signaturePad.undoSignature();
    },
  },

  mounted() {
    $(function () {
      $("#removeclass .modal-dialog ").removeClass("modal-dialog-scrollable");
    });
    this.getCategories();
    this.getPackages();
  },
};
</script>
